export function dispatchPickPlaceStatus(
  code: "PICK_MISSED" | "APPROACH_TIMEOUT" | "TARGET_POSE_MISSING"
) {
  try {
    window.dispatchEvent(new CustomEvent("ik-pickplace-status", { detail: { code } }));
  } catch {
    // ignore UI notification failures
  }
}

export function dispatchIkSolveStatus(status: string, error?: number) {
  try {
    window.dispatchEvent(new CustomEvent("ik-solve-result", { detail: { status, error } }));
  } catch {
    // ignore UI notification failures
  }
}
